import {Contact} from "../../../../../server/src/base/entities/contact/Contact";

export abstract class IContactService {
    public abstract SendEmail(contact:Contact):Promise<void>;
}

export class FakeContactService extends IContactService{
    public SendEmail(contact: Contact): Promise<void> {
        return Promise.resolve();
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/domain/mailing/IContactService.ts